import { Layout } from 'antd';
import styled, { css } from 'styled-components';
import { Button as ButtonAtom } from 'components/atoms/button';
import { NotificationsBadge } from 'components/molecules/notifications-badge';
import { DynamicMenu } from './dynamic-menu';

export const Sidebar = styled(Layout.Sider)`
  overflow: auto;
  padding: 0;

  /* Inline style overrides, so !important is unavoidable */
  width: var(--side-nav-width) !important;
  min-width: var(--side-nav-width) !important;
  max-width: var(--side-nav-width) !important;
  flex: 0 0 var(--side-nav-width) !important;

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    padding: 0 0 var(--layout-02) 0;
  }

  .ant-layout-sider-trigger {
    display: none;
  }
  background: var(--side-nav-bg);
  /* added so that when notifications drawer opens, it opens from beneath the left nav */
  z-index: var(--zindex-popover-high);
`;

const ButtonStyling = css`
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--side-nav-width);
  height: var(--side-nav-width);
`;

export const PrimaryMenu = styled(DynamicMenu)`
  flex: 1;
`;

export const Badge = styled(NotificationsBadge)`
  color: var(--side-nav-text);
`;

export const ButtonWrapper = styled.div`
  ${ButtonStyling};
  height: 48px;
`;

export const NotificationsButtonWrapper = styled.div`
  ${ButtonStyling};
  height: 36px;
  margin-top: var(--spacing-03);
  svg {
    transition: width 0.2s ease-in;
  }
  &:hover {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const Button = styled(ButtonAtom)`
  background: transparent;
  border: none;
  color: var(--side-nav-text);
`;
